// 简单的全局事件工具，用于在组件间传递 AI 任务完成信号

export const AI_TASK_COMPLETED_EVENT = 'ai-task-completed';

export function emitAITaskCompleted(res: any): void {
  try {
    const event = new CustomEvent(AI_TASK_COMPLETED_EVENT, {
      detail: res
    } as any);
    window.dispatchEvent(event);
  } catch (err) { 
    const payload: any = res;
    (window as any).dispatchEvent({ type: AI_TASK_COMPLETED_EVENT, detail: payload });
  }
}

export function subscribeAITaskCompleted(handler: (res: any) => void): () => void {
  const listener = (e: Event) => {
    const ev = e as CustomEvent<any>;
    // const taskId = ev?.detail?.taskId ?? (ev as any)?.detail?.taskId;
    handler(ev?.detail);
  };
  window.addEventListener(AI_TASK_COMPLETED_EVENT, listener as EventListener);
  return () => window.removeEventListener(AI_TASK_COMPLETED_EVENT, listener as EventListener);
}